import { useRequest } from "ahooks";
import { Select } from "antd";
import { department as departmentService } from "@/services";

function DepartmentSelect({ value, onChange, token, ...props }) {
  const { data = [], loading } = useRequest(
    () => departmentService.listTarget(token.token),
    {
      ready: !!token,
      refreshDeps: [token],
    }
  );
  const options = data.map((o) => (
    <Select.Option key={`target-option-${o.id}`} value={o.id}>
      {o.name}
    </Select.Option>
  ));
  return (
    <Select value={value} onChange={onChange} loading={loading} {...props}>
      {options}
    </Select>
  );
}

export default DepartmentSelect;
